import axios from 'axios'

export default {
    getEmployers: () => axios.get('admin/rrhh/employers'),
    getEmployer: (employer_id) => axios.get('admin/rrhh/'+employer_id+'/employer'),
    getEmployees: (employer_id) => axios.get('admin/rrhh/'+employer_id+'/employees'),

    storeEmployer: (data) => axios.post('admin/rrhh/employers/store', data),
    updateEmployer: (data) => axios.post('admin/rrhh/employers/update', data),
    deleteEmployer: (data) => axios.post('admin/rrhh/employers/delete', data),
}